import { ca } from '@cian/analytics';

import { INewbuildingDecorationType } from '../../types/newobject/newbuildingDecorations';

export const trackClickNewbuildingDecoration = (label: INewbuildingDecorationType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'click_finish_jk',
    label,
  });
};

export const trackClickNewbuildingCurrentDecoration = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'click_finish_offer_sopr',
    label,
  });
};

export const trackPhoneOpen = (label: string) => {
  ca('eventSite', {
    category: 'Phones',
    action: 'Open_card_decoration_block',
    label,
    useLastProducts: true,
  });
};

export const trackDecorationMoreButtonClick = () => {
  ca('eventSite', {
    action: 'click',
    category: 'Finish_jk',
    label: 'more_flats',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
    },
  });
};
